import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-production-orders',
    templateUrl: './production-orders.component.html',
    styleUrls: ['./production-orders.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProductionOrdersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
